/**
 * @Description: 不同客户的耗材信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  CustomerMaterialsModel,
  CustomerMaterialsSearchModel,
  CustomerMaterialsPageSearchModel,
  CustomerMaterialsAddModel,
  CustomerMaterialsUpdateModel,
  IdsModel
} from '@/model/product/CustomerMaterialsModel'

const baseUrl = Route.product + '/customerMaterials'

/**
 * 搜索分页数据
 */
export const pageSearchCustomerMaterials = (param: CustomerMaterialsPageSearchModel) => {
  return https().request<RootObject<PageRespModel<CustomerMaterialsModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchCustomerMaterials = (param: CustomerMaterialsSearchModel) => {
  return https().request<RootObject<CustomerMaterialsModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getCustomerMaterials = (id: number) => {
  return https().request<RootObject<CustomerMaterialsModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addCustomerMaterials = (param: CustomerMaterialsAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateCustomerMaterials = (param: CustomerMaterialsUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeCustomerMaterials = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveCustomerMaterials = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
